import {
  DatePicker,
  Select,
  Table,
  Typography,
  Breadcrumb,
  Button,
  Form,
  Row,
  Col,
} from "antd";
import {
  actionGetTicketAgentYearlyReportAll,
  clearReportData,
} from "../../store/actions/reportAction";
import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { actionGetUsersAllData } from "../../store/actions/userAction";
import GoBackButton from "../comman/GoBackButton";
import dayjs from "dayjs";

const TicketAgentYearlyReport = ({
  agentTicketYearlyReportLoader,
  agentTicketYearlyReportData,
  actionGetTicketAgentYearlyReportAll,
  agentTicketYearlyReportCount,
  agentTicketExportYearlyReportData,
  allUsersData,
  allUsersLoader,
  actionGetUsersAllData,
  clearReportData,
}) => {
  const [current1, setCurrent1] = useState(1);
  const [year, setYear] = useState("");
  const [form] = Form.useForm();
  const [user, setUser] = useState("");
  const [level, setLevel] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    actionGetUsersAllData(0, 10);
    actionGetTicketAgentYearlyReportAll(0, 10);
  }, []);

  const Navigate = useNavigate();

  const columns1 = [
    {
      title: "Agent",
      dataIndex: "agent",
      key: "agent",
      fixed: "left",
      width: 200,
    },
    // Add columns for each month
    {
      title: "Jan",
      dataIndex: "january",
      key: "january",
      width: 100,
    },
    {
      title: "Feb",
      dataIndex: "february",
      key: "february",
      width: 100,
    },
    {
      title: "Mar",
      dataIndex: "march",
      key: "march",
      width: 100,
    },
    {
      title: "Apr",
      dataIndex: "april",
      key: "april",
      width: 100,
    },
    {
      title: "May",
      dataIndex: "may",
      key: "may",
      width: 100,
    },
    {
      title: "Jun",
      dataIndex: "june",
      key: "june",
      width: 100,
    },
    {
      title: "Jul",
      dataIndex: "july",
      key: "july",
      width: 100,
    },
    {
      title: "Aug",
      dataIndex: "august",
      key: "august",
      width: 100,
    },
    {
      title: "Sep",
      dataIndex: "september",
      key: "september",
      width: 100,
    },
    {
      title: "Oct",
      dataIndex: "october",
      key: "october",
      width: 100,
    },
    {
      title: "Nov",
      dataIndex: "november",
      key: "november",
      width: 100,
    },
    {
      title: "Dec",
      dataIndex: "december",
      key: "december",
      width: 100,
    },
    // Add Total column
    {
      title: "Total",
      dataIndex: "total",
      fixed: "right",
      key: "total",
      width: 150,
    },
  ];

  let januaryTotal = 0;
  let februaryTotal = 0;
  let marchTotal = 0;
  let aprilTotal = 0;
  let mayTotal = 0;
  let juneTotal = 0;
  let julyTotal = 0;
  let augustTotal = 0;
  let septemberTotal = 0;
  let octoberTotal = 0;
  let novemberTotal = 0;
  let decemberTotal = 0;
  let Total = 0;

  const data1 = [];
  agentTicketYearlyReportData &&
    agentTicketYearlyReportData.length > 0 &&
    agentTicketYearlyReportData.map((e, index) => {
      // Total Find For Summary of All Months
      januaryTotal += e.data.January ? e.data.January : 0;
      februaryTotal += e.data.February ? e.data.February : 0;
      marchTotal += e.data.March ? e.data.March : 0;
      aprilTotal += e.data.April ? e.data.April : 0;
      mayTotal += e.data.May ? e.data.May : 0;
      juneTotal += e.data.June ? e.data.June : 0;
      julyTotal += e.data.July ? e.data.July : 0;
      augustTotal += e.data.August ? e.data.August : 0;
      septemberTotal += e.data.September ? e.data.September : 0;
      octoberTotal += e.data.October ? e.data.October : 0;
      novemberTotal += e.data.November ? e.data.November : 0;
      decemberTotal += e.data.December ? e.data.December : 0;
      Total += e.total ? e.total : 0;

      data1.push({
        key: index,
        agent: e.name,
        // january: e.data.January !== "00:00" ? e.data.January : "-",
        january:
          e.data.January && e.data.January !== "0" ? e.data.January : "-",
        february:
          e.data.February && e.data.February !== "0" ? e.data.February : "-",
        march: e.data.March && e.data.March !== "0" ? e.data.March : "-",
        april: e.data.April && e.data.April !== "0" ? e.data.April : "-",
        may: e.data.May && e.data.May !== "0" ? e.data.May : "-",
        june: e.data.June && e.data.June !== "0" ? e.data.June : "-",
        july: e.data.July && e.data.July !== "0" ? e.data.July : "-",
        august: e.data.August && e.data.August !== "0" ? e.data.August : "-",
        september:
          e.data.September && e.data.September !== "0" ? e.data.September : "-",
        october:
          e.data.October && e.data.October !== "0" ? e.data.October : "-",
        november:
          e.data.November && e.data.November !== "0" ? e.data.November : "-",
        december:
          e.data.December && e.data.December !== "0" ? e.data.December : "-",
        // Calculate total
        total: e.total,
      });
    });

  const handleChange = (e, val) => {
    setYear(val);
    setCurrent1(1);
  };

  const onClickPaginationNumberForAdmin = (e, t, sorter) => {
    actionGetTicketAgentYearlyReportAll(
      e.current - 1,
      e.pageSize,
      year,
      level,
      status
    );
    setCurrent1(e.current);
  };
  const breadcrumbItems = [
    {
      key: "back",
      title: (
        <>
          <GoBackButton />
        </>
      ),
      onClick: () => Navigate(-1),
    },
  ];

  useEffect(() => {
    if (
      agentTicketExportYearlyReportData &&
      agentTicketExportYearlyReportData.length > 0
    ) {
      const data =
        agentTicketExportYearlyReportData &&
        agentTicketExportYearlyReportData.map((data) => ({
          Agent: data && data.name ? data.name : "-",
          Jan: data.data.January ? data.data.January : "-",
          Feb: data.data.February ? data.data.February : "-",
          Mar: data.data.March ? data.data.March : "-",
          Apr: data.data.April ? data.data.April : "-",
          May: data.data.May ? data.data.May : "-",
          Jun: data.data.June ? data.data.June : "-",
          Jul: data.data.July ? data.data.July : "-",
          Aug: data.data.August ? data.data.August : "-",
          Sep: data.data.September ? data.data.September : "-",
          Oct: data.data.October ? data.data.October : "-",
          Nov: data.data.November ? data.data.November : "-",
          Dec: data.data.December ? data.data.December : "-",
          Total: data.total ? data.total : "-",
        }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet2");
      // Generate the Excel file and initiate the download
      XLSX.writeFile(workbook, "SAP_MonthlyAgentProductivity_Report.xlsx");
      clearReportData();
    }
  }, [agentTicketExportYearlyReportData]);

  const exportLogToExcel = () => {
    try {
      actionGetTicketAgentYearlyReportAll(
        0,
        10,
        year,
        user,
        level,
        status,
        "YES"
      );
    } catch (err) {
      console.log(err);
    }
  };
  const agentData = [];
  allUsersData?.map((data, index) => {
    if (data.roles === "AGENT") {
      agentData.push({
        key: index,
        label: data.first_name + " " + data.last_name,
        value: data.first_name + " " + data.last_name,
        // value: data.id,
      });
    }
  });

  const handleFinish = (value) => {
    setCurrent1(1);
    actionGetTicketAgentYearlyReportAll(
      0,
      10,
      year,
      value.user,
      value.level,
      value.status
    );
  };
  const handleChangeAgent = (val) => {
    setUser(val);
    setCurrent1(1);
  };
  const handleChangeStatus = (val) => {
    setStatus(val);
    setCurrent1(1);
  };
  const handleChangeLevel = (val) => {
    setUser(val);
    setCurrent1(1);
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onSearch = (value) => {
    console.log("search:", value);
  };
  return (
    <>
      <Breadcrumb items={breadcrumbItems} className="mb-3" />

      <div>
        {" "}
        <p className=" text-[24px] font-semibold">
          Monthly Agent Productivity Overview
        </p>
        <Form onFinish={handleFinish} className="mt-8" form={form}>
          <Row gutter={[16, 16]}>
            <Col span={4}>
              <Form.Item className="mb-4" name="user">
                <Select
                  onClear={() => setUser("")}
                  style={{ padding: "6px 0" }}
                  className="width  py-[7px] h-full  rounded border border-true w-full"
                  showSearch
                  allowClear
                  placeholder="Select Agent"
                  onChange={handleChangeAgent}
                  onSearch={onSearch}
                  filterOption={filterOption}
                  options={agentData}
                  loading={allUsersLoader}
                  disabled={allUsersLoader}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item className="mb-4" name="year">
                <DatePicker
                  disabledDate={(current) => current && current.year() < 2023}
                  onChange={handleChange}
                  className="w-full outline-none ring-0 focus:outline-none mb-4 border border-true"
                  picker="year"
                />
              </Form.Item>
            </Col>
            {/*  <Col span={4}>
              <Form.Item className="mb-4" name="level">
                <Select
                  onClear={() => setLevel("")}
                  style={{ padding: "6px 0" }}
                  className="width rounded py-[7px] h-full border border-true w-full"
                  showSearch
                  allowClear
                  placeholder="Select Level"
                  onChange={handleChangeLevel}
                  onSearch={onSearch}
                  filterOption={filterOption}
                  options={[
                    {
                      value: "Level 1",
                      label: "Level 1",
                    },
                    {
                      value: "Level 2",
                      label: "Level 2",
                    },
                    {
                      value: "Level 3",
                      label: "Level 3",
                    },
                    {
                      value: "Level 4",
                      label: "Level 4",
                    },
                    {
                      value: "CR",
                      label: "CR",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item className="mb-4" name="status">
                <Select
                  onClear={() => setStatus("")}
                  style={{ padding: "6px 0" }}
                  className="width rounded py-[7px] h-full border border-true w-full"
                  showSearch
                  allowClear
                  placeholder="Select Status"
                  onChange={handleChangeStatus}
                  onSearch={onSearch}
                  filterOption={filterOption}
                  options={[
                    {
                      value: "REGISTERED",
                      label: "Registered",
                    },
                    {
                      value: "IN_PROCESS",
                      label: "In Process",
                    },
                    {
                      value: "AWAITING_BUSINESS_CONFIRMATION",
                      label: "Await Business Confirmation",
                    },
                    {
                      value: "CLOSED",
                      label: "Closed",
                    },
                    {
                      label: "On Hold By Business",
                      value: "ON_HOLD_BY_BUSINESS",
                    },
                    {
                      value: "ON_HOLD_BY_ADMIN",
                      label: "On Hold By Dev Team",
                    },
                  ]}
                />
              </Form.Item>
            </Col> */}

            <Col span={4}>
              <Form.Item>
                <Button
                  className="min-h-[42px] outline-none focus:shadow-none focus-visible:outline-0 focus-visible:outline-offset-0"
                  type="primary"
                  htmlType="submit"
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
            <div className="ml-auto mr-3">
              <Button
                className="min-h-[42px] outline-none focus:shadow-none focus-visible:outline-0 focus-visible:outline-offset-0 flex items-center justify-center"
                onClick={exportLogToExcel}
              >
                <ExportOutlined />
                Export
              </Button>
            </div>
          </Row>
        </Form>
        <Table
          bordered
          className="user-table"
          sticky={true}
          size="small"
          pagination={{
            current: current1,
            total: agentTicketYearlyReportCount,
            hideOnSinglePage: true,
          }}
          summary={(pageData) => {
            return (
              <>
                <Table.Summary.Row fixed>
                  <Table.Summary.Cell index={0} className="font-bold">
                    Total
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} className="font-semibold">
                    {januaryTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} className="font-semibold">
                    {februaryTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} className="font-semibold">
                    {marchTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} className="font-semibold">
                    {aprilTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} className="font-semibold">
                    {mayTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} className="font-semibold">
                    {juneTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} className="font-semibold">
                    {julyTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={8} className="font-semibold">
                    {augustTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={9} className="font-semibold">
                    {septemberTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={10} className="font-semibold">
                    {octoberTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={11} className="font-semibold">
                    {novemberTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={12} className="font-semibold">
                    {decemberTotal.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={13} className="font-bold">
                    {Total.toFixed(2)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
          columns={columns1}
          dataSource={data1}
          loading={agentTicketYearlyReportLoader}
          onChange={(e) => onClickPaginationNumberForAdmin(e)}
          scroll={{
            x: "max-content",
          }}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfileData: state.auth.userProfileData,
    agentTicketYearlyReportLoader: state.report.agentTicketYearlyReportLoader,
    agentTicketYearlyReportData: state.report.agentTicketYearlyReportData,
    agentTicketYearlyReportCount: state.report.agentTicketYearlyReportCount,
    agentTicketExportYearlyReportData:
      state.report.agentTicketExportYearlyReportData,
    allUsersLoader: state.users.allUsersLoader,
    allUsersData: state.users.allUsersData,
  };
};

export default connect(mapStateToProps, {
  actionGetTicketAgentYearlyReportAll,
  actionGetUsersAllData,
  clearReportData,
})(TicketAgentYearlyReport);
